import React from "react";

interface HamburgerButtonProps {
    isOpen: boolean;
    isScrolled: boolean;
    onClick: () => void;
}

const HamburgerButton: React.FC<HamburgerButtonProps> = ({
    isOpen,
    isScrolled,
    onClick,
}) => {
    return (
        <div className="lg:hidden block">
            <button
                id="hamburger-button"
                onClick={onClick}
                className={`
          p-3 
          border 
          flex flex-col items-center justify-center space-y-1 z-40 relative
          transition-colors duration-300
          ${isScrolled ? "border-[#040405]" : "border-border-light"}
          ${isOpen ? "openbar" : "closebar"}
        `}
                aria-label="Toggle menu"
            >
                <span
                    className={`
            w-[18px] h-0.5 transition-all duration-300 ease-in-out
            ${isOpen ? "translate-y-1.5 rotate-45 bg-secondary-text" : ""}
            ${isScrolled ? "bg-[#040405]" : "bg-primary-text-white"}
          `}
                ></span>
                <span
                    className={`
            w-[18px] h-0.5 transition-all duration-300 ease-in-out
            ${isOpen ? "opacity-0" : ""}
            ${isScrolled ? "bg-[#040405]" : "bg-primary-text-white"}
          `}
                ></span>
                <span
                    className={`
            w-[18px] h-0.5 transition-all duration-300 ease-in-out
            ${isOpen ? "-translate-y-1.5 -rotate-45 bg-secondary-text" : ""}
            ${isScrolled ? "bg-[#040405]" : "bg-primary-text-white"}
          `}
                ></span>
            </button>
        </div>
    );
};

export default HamburgerButton;
